"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
function Header() {
    return (react_1.default.createElement("header", { id: "full-header" },
        react_1.default.createElement("a", { id: "logo" },
            react_1.default.createElement("img", { src: "711ebe8d03035220e9db.svg" })),
        react_1.default.createElement("hr", null),
        react_1.default.createElement("a", { href: "#about-us" }, "About Us"),
        react_1.default.createElement("a", { href: "#robots" }, "Robots"),
        react_1.default.createElement("a", { href: "#contact" }, "Sponsors"),
        react_1.default.createElement("a", { href: "#footer" }, "Contact Us")));
}
exports.default = Header;
